module.exports = __webpack_public_path__ + "img/shape01.a9d8bdb9.svg";